import { render, staticRenderFns } from "./Destinations.vue?vue&type=template&id=4d48c969"
import script from "./Destinations.vue?vue&type=script&lang=js"
export * from "./Destinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports